<template>
  <div class="container" v-wechat-title="$route.meta.title">
    <!-- 客户报表 -->
    <div class="onePart">
      <div
        v-if="changeIndex == 0"
        v-bind:class="{ day:changeIndex== 0,'date-bar':1}"
      >{{showDate(beginDay)}}</div>
      <div v-if="changeIndex == 2" class="date-bar">
        {{showDate(beginDay,'y')}}
        <span @click="selectDate('sub')">&lt;&lt;</span>
        {{showDate(beginDay,'m')}}
        <span @click="selectDate('add')">&gt;&gt;</span>
      </div>
      <div v-if="changeIndex == 3" class="date-bar">
        <span @click="selectDate('sub')">&lt;&lt;</span>
        {{showDate(beginDay,'y')}}
        <span @click="selectDate('add')">&gt;&gt;</span>
      </div>
      <div v-if="changeIndex == 1" class="date-bar">
        {{showDate(beginDay,'y')}}
        <span @click="selectDate('sub')">&lt;&lt;</span>
        {{showDate(beginDay,'d')}} - {{showDate(endDay,'d')}}
        <span
          @click="selectDate('add')"
        >&gt;&gt;</span>
      </div>

      <div class="topChange disp-just-aro-ali-cen">
        <div @click="changeType" :index="0" :class="[changeIndex==0?'div1':'div2']">今日</div>
        <div @click="changeType" :index="1" :class="[changeIndex==1?'div1':'div2']">周报</div>
        <div @click="changeType" :index="2" :class="[changeIndex==2?'div1':'div2']">月报</div>
        <div @click="changeType" :index="3" :class="[changeIndex==3?'div1':'div2']">年报</div>
      </div>
      <div class="wrap disp-ali-cen">
        <div
          class="info info5 disp-just-aro-ali-cen-fldir-col"
          :class="changeIndex==1||changeIndex==2?'info_1':'' "
        >
          <div v-if="changeIndex == 0" class="div-relative">今日新增客户（人）<p @click="checkQues('今日新增客户_'+(changeIndex+1))" class="ques"></p></div>
          <div v-else  class="div-relative">新增客户（人）<p @click="checkQues('新增客户_'+(changeIndex+1))" class="ques"></p></div>
          <div>{{getOneDimension("新增客户总数",0)}}</div>
          <div v-if="changeIndex == 0">昨日新增客户：{{getOneDimension("昨日新增客户总数",0)}}</div>
          <div v-if="changeIndex != 0"> </div>
        </div>
        <div v-if="changeIndex == 0" class="info info5 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">累计客户总数<p @click="checkQues('累计客户总数_'+(changeIndex+1))" class="ques"></p></div>
          <div>{{getOneDimension("客户总数",0)}}</div>
          <div>{{LastTime}}</div>
        </div>
        <div v-if="changeIndex == 3" class="info info5 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">老客户消费频次（次/月）</div>
          <div>{{getOneDimension("老客户消费频次",0)}}</div>
          <div style="opacity: 0;">新增客户：2</div>
        </div>
      </div>
    </div>

    <!-- 客户类型构成 -->
    <div v-if="changeIndex == 0" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">客户类型构成（人）<p @click="checkQues('客户类型构成_'+(changeIndex+1))" class="ques2"></p></div>
      <div id="pieOne" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
     <!-- 客户性别比例 -->
    <div v-if="changeIndex == 0" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">客户性别比例（人）<p @click="checkQues('客户性别比例_'+(changeIndex+1))" class="ques2"></p></div>
      <div id="pieTwo" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>

    <!-- 会员类型占比 -->
    <div v-show="changeIndex == 0" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">会员类型占比（人）<p @click="checkQues('会员类型占比_'+(changeIndex+1))" class="ques2"></p></div>
      <div id="pieThree" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
     <!-- 客户属性分布 -->
    <div v-if="changeIndex == 0" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">客户属性分布（人）<p @click="checkQues('客户属性分布_'+(changeIndex+1))" class="ques2"></p></div>
      <div id="pieFour" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>

       <!-- 客户车辆车型数量 -->
    <div v-if="changeIndex == 0"  class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        客户车辆车型数量（辆）<p @click="checkQues('客户车辆车型数量_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="barOne" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <!-- 客户车辆行驶里程分布 -->
    <div v-show="changeIndex == 0" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">客户车辆行驶里程分布（辆）<p @click="checkQues('客户车辆行驶里程分布_'+(changeIndex+1))" class="ques2"></p></div>
      <div id="pieCar" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
     <!-- 客户累积消费金额阶梯分布 -->
    <div v-show="changeIndex == 0" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">客户累积消费金额阶梯分布（人）<p @click="checkQues('客户累积消费金额阶梯分布_'+(changeIndex+1))" class="ques2"></p></div>
      <div id="pieCustAmount" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>

    <!-- 客户流失率统计 -->
    <template v-if="changeIndex == 3">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">客户流失率统计（百分比%）<p @click="checkQues('客户流失率统计_'+(changeIndex+1))" class="ques2"></p></div>
      <div id="categoryOne" :style="{width:'100%',height:'5.06rem'}"></div>
    </template>

    <van-popup v-model="show1" :overlay="false" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :min-date="minDate1"
        :max-date="maxDate1"
        :formatter="formatter"
        @confirm="sureDate"
        @cancel="show1 = false"
      />
    </van-popup>
    <div class="divPlaceholder">&nbsp;</div>
    <!-- loading的显示隐藏 -->

    <Loading v-show="loadShow"></Loading>
    <popupWin v-if="popupIsShow" :popupShow="isPopupShow" :keyWords="keyWord" @childRe="childReturn"></popupWin>
  </div>
</template>
<script>
import Vue from "vue";
import util from "../../static/js/util";
import { Toast } from "vant";
Vue.use(Toast);
import baseUrl from "../../static/js/basedata.js";
import { Loading } from "vant";
Vue.use(Loading);

export default {
  name: "InfoPage",
  data() {
    return {
      changeIndex: 0,
      beginDay: new Date(),
      endDay: new Date(),
      RptData: {},
      loadShow: false,
      show: false,
      minDate: new Date(),
      maxDate: new Date(2999, 1, 1),
      show1: false,
      minDate1: new Date(2000, 1, 1),
      maxDate1: new Date(2999, 12, 31),
      currentDate: new Date(),
      YearData: "",
      isPopupShow: false,
      keyWord:'',//带入组件关键字
      popupIsShow:false,
      popupShow:false,//底部弹框是否显示
      keyWords:'',
      popupTitle:'弹框标题',//弹框标题
      popupContent:'弹框内容',//弹框标题
    };
  },
  computed: {
    getDate: function() {
      if (this.changeIndex == 0) {
        return this.formatDate(new Date(this.beginDay));
      } else {
        return `${this.formatDate(new Date(this.beginDay))} - ${this.formatDate(
          new Date(this.endDay)
        )}`;
      }
    },
     LastTime: function() {
            if (this.RptData.LastUpdateTime){
             var timeS = this.RptData.LastUpdateTime.replace(/-/g,"/"); 
                return (
                    "更新时间:" +
                    new Date(timeS).format("MM/dd hh:mm")
                );}
            return "";
        }
  },
  methods: {
    checkQues(_key){
      console.log(_key)
      this.isPopupShow = true;
      this.keyWord = _key;
      this.popupIsShow = true;
    },
    childReturn(data){
      console.log('data-----',data)
      this.isPopupShow = data;
      this.popupIsShow = data;
    },
    showDateSelect() {
      this.show1 = !this.show1;
    },
    sureDate(res) {
      this.showDateSelect();
      this.YearData = this.formatDate(res);

      this.beginDay = this.formatDate(res) + "-01-01";
      this.endDay = this.formatDate(res) + "-12-31";

      this.loadData();
    },
    showDate(date, mode) {
      // 今日选择
      mode = mode || "a";
      date = new Date(date);
      if (this.changeIndex == 0) {
        return `${date.getFullYear()}年${date.getMonth() +
          1}月${date.getDate()}日`;
      } else if (this.changeIndex == 1) {
        if (mode === "y") {
          return `${date.getFullYear()}年`;
        }
        if (mode === "d") return `${date.getMonth() + 1}月${date.getDate()}日`;
      } else if (this.changeIndex == 2) {
        // 月选择
        if (mode === "y") {
          return `${date.getFullYear()}年`;
        }
        if (mode === "m") return `${date.getMonth() + 1}月`;
      } else if (this.changeIndex == 3) {
        // 月选择
        if (mode === "y") {
          return `${date.getFullYear()}年`;
        }
      }
    },
    selectDate(mode) {
      if (this.changeIndex == 2) {
        if (mode === "add") {
          var date = new Date(this.beginDay);
          date.setDate(1);
          date.setMonth(date.getMonth() + 1);
          this.beginDay = date.format("yyyy-MM-dd");
          var date = new Date(this.beginDay);
          date.setMonth(date.getMonth() + 1);
          date.setDate(0);
          this.endDay = date.format("yyyy-MM-dd");
        } else if (mode === "sub") {
          var date = new Date(this.beginDay);
          date.setDate(1);
          date.setMonth(date.getMonth() - 1);
          this.beginDay = date.format("yyyy-MM-dd");
          var date = new Date(this.beginDay);
          date.setMonth(date.getMonth() + 1);
          date.setDate(0);
          this.endDay = date.format("yyyy-MM-dd");
        }
        this.loadData();
      }
      if (this.changeIndex == 1) {
        if (mode === "add") {
          var date = new Date(this.beginDay);
          date.setDate(date.getDate() + 7);
          this.beginDay = date.format("yyyy-MM-dd");
          var date = new Date(this.beginDay);
          date.setDate(date.getDate() + 6);
          this.endDay = date.format("yyyy-MM-dd");
        } else if (mode === "sub") {
          var date = new Date(this.beginDay);
          date.setDate(date.getDate() - 7);
          this.beginDay = date.format("yyyy-MM-dd");
          var date = new Date(this.beginDay);
          date.setDate(date.getDate() + 6);
          this.endDay = date.format("yyyy-MM-dd");
        }
        this.loadData();
      }
      if (this.changeIndex == 3) {
        if (mode === "add") {
          var date = new Date(this.beginDay);
          date.setFullYear(date.getFullYear() + 1);
          this.beginDay = date.format("yyyy-MM-dd");
          var date = new Date(this.endDay);
          date.setFullYear(date.getFullYear() + 1);
          this.endDay = date.format("yyyy-MM-dd");
        } else if (mode === "sub") {
          var date = new Date(this.beginDay);
          date.setFullYear(date.getFullYear() - 1);
          this.beginDay = date.format("yyyy-MM-dd");
          var date = new Date(this.endDay);
          date.setFullYear(date.getFullYear() - 1);
          this.endDay = date.format("yyyy-MM-dd");
        }
        this.loadData();
      }
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    formatDate(date) {
      // 今日选择
      if (this.changeIndex == 0) {
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      } else if (this.changeIndex == 1) {
        // 周选择
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      } else if (this.changeIndex == 2) {
        // 月选择
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      } else if (this.changeIndex == 3) {
        // 月选择
        return `${date.getFullYear()}`;
      }
    },
    onConfirm(date) {
      if (this.changeIndex == 0) {
        this.beginDay = date.format("yyyy-MM-dd");
        this.endDay = date.format("yyyy-MM-dd");
      } else {
        const [start, end] = date;
        this.beginDay = start.format("yyyy-MM-dd");
        this.endDay = end.format("yyyy-MM-dd");
      }
      this.loadData();
    },
    changeType(e) {
      var index = e.target.getAttribute("index");
      this.changeIndex = Number(index);
      var date = this.$dateUtil.today();
      switch (this.changeIndex) {
        case 0:
          date = this.$dateUtil.today();
          break;
        case 1:
          date = this.$dateUtil.thisWeek();
          break;
        case 2:
          date = this.$dateUtil.thisMonth();
          break;
        case 3:
          date = this.$dateUtil.thisYear();
          break;
      }
      this.beginDay = date.Begin;
      this.endDay = date.End;
      this.loadData();
    },
    loadData() {
      var that = this;
      that.loadShow = true;
      that.show = false;
      var query = {
        ReportType: that.$util.AppReportType.客户报表,
        Begin: that.beginDay,
        End: that.endDay
      };
      this.$api.get(
        "/AppReport",
        query,
        function(res) {
          that.RptData = res;
          that.drawPie();
          that.loadShow = false;
        },
        function(err) {
          that.loadShow = false;
        }
      );
    },
    getOneDimension(subTypeName, def) {
      return this.$util.getOneDimension(this.RptData.Items, subTypeName, def);
    },
    getTwoDimension(subTypeName, defX, defY) {
      return this.$util.getTwoDimension(
        this.RptData.Items,
        subTypeName,
        defX,
        defY
      );
    },
    getTwoDimensionBar(subTypeName, defY, defValue, valueColumn) {
      return this.$util.getTwoDimensionBar(
        this.RptData.Items,
        subTypeName,
        defY,
        defValue,
        valueColumn
      );
    },
    drawPie() {
      if (this.changeIndex == 0) {
        var pieOneData = this.getTwoDimension("新老客户构成", "客户", "0");
        this.$echarts
          .init(document.getElementById("pieOne"))
          .setOption(this.$util.PieOption(pieOneData, "人"));

           var pieTwoData = this.getTwoDimension("客户性别比例", "客户", "0");
        this.$echarts
          .init(document.getElementById("pieTwo"))
          .setOption(this.$util.PieOption(pieTwoData, "人"));

        var pieThreeData = this.getTwoDimension(
          "客户会员类型占比",
          "会员",
          "0"
        );
        this.$echarts
          .init(document.getElementById("pieThree"))
          .setOption(this.$util.PieOption(pieThreeData, "人"));

 var pieFourData = this.getTwoDimension("客户属性分布", "客户", "0");
        this.$echarts
          .init(document.getElementById("pieFour"))
          .setOption(this.$util.PieOption(pieFourData, "人"));

 var barOneData = this.getTwoDimensionBar("客户车辆车型数量", "其他", "0");
        this.$echarts.init(document.getElementById('barOne')).setOption(
            this.$util.BarOption(barOneData,"车型")
        );

        var pieCarData = this.getTwoDimension(
          "客户车辆行驶里程分布",
          "里程",
          "0"
        );
        this.$echarts
          .init(document.getElementById("pieCar"))
          .setOption(this.$util.PieOption(pieCarData, "辆"));

          var pieCustAmountData = this.getTwoDimension(
          "客户累积消费金额阶梯分布",
          "金额",
          "0"
        );
        this.$echarts
          .init(document.getElementById("pieCustAmount"))
          .setOption(this.$util.PieOption(pieCustAmountData, "人"));
      }

      if (this.changeIndex == 3) {
        var categoryOneData = this.getTwoDimensionBar(
          "客户流失率统计",
          "流失率",
          "0"
        );
        this.$echarts
          .init(document.getElementById("categoryOne"))
          .setOption(this.$util.LineOption(categoryOneData));
      }
    }
  },
  mounted() {
    var date = this.$dateUtil.today();
    this.beginDay = date.Begin;
    this.endDay = date.End;
    this.YearData = new Date().getFullYear();
    this.loadData();
    phoneDevice.setTitle(this.$route.meta.title || "");
  }
};
</script>

<style>
@import url("../../static/css/common.css");
.van-picker__columns div:nth-child(2) {
  display: none;
}
table {
  border: 0.01rem solid #ececec;
}
.thClass {
  text-align: center;
  height: 1rem;
  color: #999999;
  font-size: 0.32rem;
}
.tdClass {
  text-align: center;
  height: 1rem;
  font-size: 0.32rem;
}
.topChange {
  width: 100%;
  margin-bottom: 0.53rem;
}
.topChange .div1 {
  width: auto;
  font-size: 0.34rem;
  color: #1c1c1c;
  border-bottom: 0.05rem solid #1699e5;
}
.topChange .div2 {
  width: auto;
  font-size: 0.34rem;
  color: #999999;
  border-bottom: 0.05rem solid transparent;
}
.container {
  width: 10rem;
  min-height: 100vh;
  background: #f2f2f2;
  /* background: pink; */
  padding: 0 0.34rem;
  box-sizing: border-box;
  border-top: 0.01rem solid transparent;
}

.wrap .info1 {
  background-image: url(../assets/indexImage/img10.png);
}

.wrap .info2 {
  background-image: url(../assets/indexImage/img2.png);
}

.wrap .info3 {
  background-image: url(../assets/indexImage/img4.png);
}

.wrap .info4 {
  background-image: url(../assets/indexImage/img6.png);
}

.wrap .info5 {
  background-image: url(../assets/indexImage/img12.png);
}

.wrap .info6 {
  background-image: url(../assets/indexImage/img8.png);
}
</style>



// WEBPACK FOOTER //
// src/components/kehubaobiao.vue